/** Horizontálně scrollovatelné chipy kategorií; navigují na /kategorie/:slug. */

import { Link } from 'react-router-dom';
import { useCategories } from '../lib/queries';
import { categoryIcon } from '../lib/format';

export default function CategoryChips({ activeSlug }: { activeSlug?: string }) {
  const { data, isLoading } = useCategories();
  // Prázdné kategorie (bez zveřejněného materiálu) se zákazníkům neukazují,
  // ledaže je právě otevřená (aby aktivní chip nezmizel).
  const categories = (data ?? []).filter((cat) => cat.product_count > 0 || cat.slug === activeSlug);

  const base =
    'focus-ring inline-flex min-h-[44px] shrink-0 items-center gap-1.5 rounded-full px-4 py-2 text-sm font-semibold transition';
  const activeCls = 'border border-board bg-board text-chalk';
  const idleCls = 'border border-line bg-card text-ink hover:border-board';

  return (
    <div className="no-scrollbar mask-fade-x -mx-4 flex gap-2.5 overflow-x-auto px-4 pb-1">
      <Link to="/" className={`${base} ${!activeSlug ? activeCls : idleCls}`}>
        Vše
        {!activeSlug && <span className="h-1.5 w-1.5 rounded-full bg-accent" />}
      </Link>
      {isLoading &&
        Array.from({ length: 5 }).map((_, i) => (
          <span key={i} className={`${base} ${idleCls} pointer-events-none`}>
            <span className="h-3 w-16 rounded bg-paper2 motion-safe:animate-pulse" />
          </span>
        ))}
      {categories.map((cat) => {
        const Icon = categoryIcon(cat.icon);
        const active = cat.slug === activeSlug;
        return (
          <Link
            key={cat.id}
            to={`/kategorie/${cat.slug}`}
            className={`${base} ${active ? activeCls : idleCls}`}
          >
            <Icon className="h-4 w-4" strokeWidth={2} />
            {cat.name}
            {active && <span className="h-1.5 w-1.5 rounded-full bg-accent" />}
          </Link>
        );
      })}
    </div>
  );
}
